define('common/ko/fn/withFallback',['underscore', 'knockout', 'common/tools'], function(_, ko, tools) {

    ko.subscribable.fn.logger = ko.subscribable.fn.logger || ko.observable();

    /**
     * @param {Observable *} fallbackValue
     * @param {String or Function} [errorMessage]
     * @param {Function} [shouldFallback]
     */
    ko.subscribable.fn.withFallback = function(fallbackValue, errorMessage, shouldFallback) {

        var target = this,
            factory = target.map ? ko.pureComputedArray : ko.pureComputed,
            config,
            hasReportedError = false;

        config = _.chain({
                shouldFallback: shouldFallback
            })
            .defaults(target.$$fallbackConfiguration)
            .defaults({
                suppressWarnings: false,
                shouldFallback: isEmptyArrayOrBlankValue
            })
            .value();

        return factory({
            read: function() {

                var value = target(),
                    suppressWarnings,
                    finalErrorMessage = errorMessage;

                if (config.shouldFallback(value)) {

                    if ( !ko.unwrap(config.suppressWarnings) && errorMessage && !hasReportedError ) {

                        hasReportedError = true;

                        if (_.isFunction(errorMessage)) {
                            ko.ignoreDependencies(function() {
                                finalErrorMessage = errorMessage();
                            });
                        }

                        target.logger.waitForValue().then(function(LOG) {
                            LOG.error(finalErrorMessage);
                        });

                    }

                    return ko.unwrap(fallbackValue);
                }

                return value;

            },
            write: target
        });

    };

    /**
     * @return {Boolean}
     */
    function isEmptyArrayOrBlankValue(value) {

        if( _.isArray(value) ) {
            return value.length === 0;
        }

        return _.str.isBlank(value);
    }

});

